<template>
  <div class="relative">
    <img src="@/assets/images/shared/starGroupIconBrownRightSmallS2.svg" style="width: 9.5vw; top: 5%" class="absolute right-0 -z-10" />
    <img src="@/assets/images/shared/starGroupIconBrownLeftSmallS2.svg" style="width: 5vw; bottom: 5%" class="absolute left-0 -z-10" />
    <div class="ml-36 mr-20 mb-14 flex flex-col gap-y-5 text-xl text-black">
      <div>
        <div>{{ t("bivalentVaccine.vaccineApppointmentProcedure") }}</div>
        <div>{{ t("bivalentVaccine.firstStep") }}</div>
        <div>{{ t("bivalentVaccine.firstStepDesc") }}</div>
      </div>

      <div>
        <div>{{ t("bivalentVaccine.secondStep") }}</div>
        <div>{{ t("bivalentVaccine.secondStepDesc") }}</div>
      </div>

      <div>
        <div>{{ t("bivalentVaccine.thirdStep") }}</div>
        <div>{{ t("bivalentVaccine.thirdStepDesc") }}</div>
      </div>

      <div>
        <div>{{ t("bivalentVaccine.remark") }}</div>
        <template v-for="(item, index) in bivalentVaccineStore.remarkList" :key="'appointmentProcedureRemark' + index">
          <div>
            <span class="mr-3">{{ index + 1 }})</span>
            <span>{{ t(item) }}</span>
          </div>
        </template>
      </div>

      <div class="mt-5">
        <div>{{ t("bivalentVaccine.terms") }}</div>
        <div>{{ t("bivalentVaccine.refund") }}</div>
        <div v-html="t('bivalentVaccine.refundDesc')" />
      </div>

      <div>
        <div>{{ t("bivalentVaccine.termsAndAgreements") }}</div>
        <template v-for="(item, index) in bivalentVaccineStore.termsAndAgreementsList" :key="'appointmentProcedureRemark' + index">
          <div class="mb-5">
            <span class="mr-3">{{ index + 1 }})</span>
            <span>{{ t(item) }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bivalentVaccineStore = useBivalentVaccineStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>